import { useQuery } from "@tanstack/react-query";
import { useIdentity } from "context/auth";
import { FeatureFlags } from "models/websiteSettings";
import { useAuthenticatedRequest } from "./useRequests";

const useFeatureFlags = () => {
    const { isAdmin } = useIdentity();
    const { data = {}, isLoading } = useQuery(
        ["website-settings", "feature-flags"],
        useAuthenticatedRequest<FeatureFlags>({
            method: "GET",
            url: "/website-settings/feature-flags"
        }),
        { suspense: true }
    );

    const shouldConfirmPayoutRequests = (): boolean => {
        // admins never have to confirm a payout request made on a
        // user's behalf.
        if (isAdmin) {
            return false;
        }

        return data['payoutRequestConfirmation']?.enabled ?? false;
    };

    return {
        shouldConfirmPayoutRequests,
        isLoading
    };
}

export default useFeatureFlags;